<script lang="ts" setup>
const emit = defineEmits<{
  (event: 'open'): void;
  (event: 'close'): void;
}>();
const props = withDefaults(
  defineProps<{
   housingId: string | number;
   userId: string;
    state?: boolean | undefined;
    showTrigger?: boolean;
    triggerDisabled?: boolean;
  }>(),
  {
    state: undefined,
    showTrigger: false,
    triggerDisabled: false,
  }
);

const { t } = useI18n({
  useScope: 'local',
});

const internalState = ref(typeof props.state !== 'undefined' ? props.state : false);
const state = computed({
  get: () => (typeof props.state !== 'undefined' ? props.state : internalState.value),
  set: (v: boolean) => {
    internalState.value = v;
    if (internalState.value) emit('open');
    else emit('close');
  },
});

const showAllChats = ref(false);

function showAllChatsToggle() {
  showAllChats.value = !showAllChats.value;
}

</script>

<template>
  <tw-ui-modal :key="props.housingId" :show-trigger="false" :state="state" @close="showAllChats = false" @update:state="emit('close')" class="contact-modal">
    <template #title>
      {{  !showAllChats ? t('contact') : t('ring-swap-chats') }}
    </template>
    <template #header-action-left v-if="showAllChats"><Icon name="bi:chevron-left" @click="showAllChatsToggle" /></template>
    <template #trigger v-if="showTrigger">
      <tw-ui-action
        is="button"
        variant="button-primary"
        :disabled="triggerDisabled"
        @click="emit('open')">
        {{  t('to-contact') }}
      </tw-ui-action>
    </template>
    <template #default>
      <tw-pages-ring-swap-contact :hid="props.housingId"  @click:all-chats="showAllChatsToggle" :is-emit="true" v-if="!showAllChats" />
      <tw-pages-ring-swap-all-chats :tuid="props.userId" v-if="showAllChats" />
    </template>
  </tw-ui-modal>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/tw-variables.scss';
@import '@/assets/styles/tw-mixins.scss';

:deep(.tw-icon) {
  height: 1em;
}

.tw-modal {
  border-radius: 0.222em;
  min-width: 650px;
  max-width: 650px;
  max-height: 850px;
  min-height: 850px;
}

.contact-modal {
  :deep(.tw-modal--title){
    text-align: center  ;
  }
  .i-bi\:chevron-left {
    cursor: pointer;
  }
}
</style>

<i18n lang="json">
{
  "de": {
    "contact": "Kontakt",
    "ring-swap-chats": "Ringtausch Chats"
  },
  "en": {
    "contact": "Contact",
    "ring-swap-chats": "Ring Swap Chats"
  }
}
</i18n>
